import useStyles from './styles';

function Divider({ size = 'small' }: DividerProps) {
  const classes = useStyles();

  return <div className={`${classes.divider} ${classes[size]}`} />;
}

export default Divider;
